import * as yup from 'yup'

const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/

export const contact = yup.object().shape(
  {
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    employer: yup.string().required('Employer name is required'),
    email: yup.string().when('phone', {
      is: (val: string) => !val || val.length === 0,
      then: yup
        .string()
        .email('Invalid email')
        .required('Email or phone number is required'),
      otherwise: yup.string().email('Invalid email'),
    }),
    phone: yup.string().when('email', {
      is: (val: string) => val && val.length > 0,
      then: yup.string().matches(phoneRegExp, {
        excludeEmptyString: true,
        message: 'Invalid phone number',
      }),
      otherwise: yup
        .string()
        .matches(phoneRegExp, {
          excludeEmptyString: true,
          message: 'Invalid phone number',
        })
        .required('Phone number or email is required'),
    }),
    message: yup.string().required('Add a comment before continuing'),
  },
  [['phone', 'email']]
)
